var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { baseFetch } from "../../utility/api";
/**
 * Async function that will perform a fetch obtaining the BadWords list
 *
 * @returns Returns the BadWords list.
 *
 * @example
 *
 * ```ts
 * badwords.api.get()
 * ```
 */
export function get(environment) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `/assets/json/invalid-strings.json`;
        const fetcher = baseFetch({ environment });
        const response = yield fetcher(url);
        const json = yield response.json();
        return json;
    });
}
//# sourceMappingURL=index.js.map